import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const LoanGapByAmountRangeChart: React.FC = () => {
  const data = {
    labels: ['$0-1,000', '$1,000-5,000', '$5,000-10,000', '$10,000-25,000', '$25,000+'],
    datasets: [
      {
        label: 'Applications',
        data: [45, 120, 85, 65, 25],
        backgroundColor: '#8b5cf6',
        borderColor: '#8b5cf6',
        borderWidth: 0
      },
      {
        label: 'Approved',
        data: [42, 105, 68, 48, 15],
        backgroundColor: '#10b981',
        borderColor: '#10b981',
        borderWidth: 0
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        titleColor: '#ffffff',
        bodyColor: '#ffffff',
        borderColor: 'rgba(0, 0, 0, 0.1)',
        borderWidth: 1,
        cornerRadius: 8,
        padding: 12
      }
    },
    scales: {
      x: {
        grid: {
          display: false
        },
        ticks: {
          color: '#94a3b8',
          font: {
            size: 11
          },
          maxRotation: 45
        }
      },
      y: {
        grid: {
          color: 'rgba(148, 163, 184, 0.1)'
        },
        ticks: {
          color: '#94a3b8',
          font: {
            size: 11
          }
        }
      }
    }
  };

  return (
    <div className="h-80">
      <Bar data={data} options={options} />
    </div>
  );
};

export default LoanGapByAmountRangeChart;